import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// @mui
import {
  Autocomplete,
  Popover,
  Button,
  Stack,
  TextField,
  Container,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Paper,
} from '@mui/material';

// Calendario
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptLocale from 'date-fns/locale/pt-BR';

import { getProdutos, getUsuarios, getClientes, getFluxogramas, getFormasPagamento } from './api';
import { useUnidades } from '../hooks/useUnidades';

const origem = [{ nome: 'Prospecção' }, { nome: 'Agendamento' }, { nome: 'Lead' }, { nome: 'Indicação' }];


const sexos = ['Masculino', 'Feminino'];

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const PopoverFiltroHome = React.forwardRef((props, ref) => {
  const [filtro, setFiltro] = useState(props.filtro);
  // Papel do usuario: nao-supervisor nao altera consultor nem unidade
  const isSupervisor = JSON.parse(localStorage.getItem('userData'))?.supervisor;
  const [usuarios, setUsuarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [open, setOpen] = useState(false);
  const [openProdutos, setOpenProdutos] = useState(false);
  const { unidades } = useUnidades();
  const [fluxos, setFluxos] = useState([]);
  const [pagamento, setPagamento] = useState([])

  useEffect(() => {
    fectchUsuarios();
  }, []);
  const fectchUsuarios = async () => {
    const resultado = await getUsuarios();
    setUsuarios(resultado);
  };

  useEffect(() => {
    fetchClientes();
  }, []);
  const fetchClientes = async () => {
    const resultado = await getClientes();
    setClientes(resultado);
  };

  useEffect(() => {
    fetchProdutos();
  }, []);
  const fetchProdutos = async () => {
    const resultado = await getProdutos();
    setProdutos(resultado);
  };

  useEffect(() => {
    fetchEstados();
  }, []);
  const fetchEstados = async () => {
    fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erro na solicitação');
        }
        return response.json();
      })
      .then((estados) => {
        const estadosOrdenados = estados.sort((a, b) => a.nome.localeCompare(b.nome));
        setEstados(estadosOrdenados);
      })
      .catch((error) => {
        console.error('Erro ao obter os estados:', error);
      });
  };

  useEffect(() => {
    fetchCidades();
  }, [filtro.estado]);
  const fetchCidades = () => {
    if (filtro.estado) {
      fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${filtro.estado.sigla}/municipios`)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Erro na solicitação');
          }
          return response.json();
        })
        .then((cidades) => {
          const cidadesOrdenados = cidades.sort((a, b) => a.nome.localeCompare(b.nome));
          setCidades(cidadesOrdenados);
        })
        .catch((error) => {
          console.error('Erro ao obter os estados:', error);
        });
    }
  };

  useEffect(() => {
    fetchFluxos();
  }, []);
  const fetchFluxos = async () => {
    const resultado = await getFluxogramas();
    setFluxos(resultado);
  };

  useEffect(() => {
    fetchFormas();
  }, []);
  const fetchFormas = async () => {
    const resultado = await getFormasPagamento();
    setPagamento(resultado);
  };

  // Calendario
  // Calendario 1 (Data Inicial)
  const [openCalendar1, setOpenCalendar1] = useState(false);
  const handleCalendarOpen1 = () => {
    setOpenCalendar1(true);
  };
  const handleCalendarClose1 = () => {
    setOpenCalendar1(false);
  };
  const handleDateChange1 = (date) => {
    setFiltro({ ...filtro, datainicial: date });
    handleCalendarClose1(); // Feche o calendário após a seleção da data
  };

  // Calendario 2 (Data Final)
  const [openCalendar2, setOpenCalendar2] = useState(false);
  const handleCalendarOpen2 = () => {
    setOpenCalendar2(true);
  };
  const handleCalendarClose2 = () => {
    setOpenCalendar2(false);
  };
  const handleDateChange2 = (date) => {
    setFiltro({ ...filtro, datafinal: date });
    handleCalendarClose2(); // Feche o calendário após a seleção da data
  };
  // Calendario

  const handleToggle = (usuario) => () => {
    const newSelectedUsuarios = [...filtro.usuarios];
    // Verifique se o usuário já está na lista com base no _id
    const userIndex = newSelectedUsuarios.findIndex((selectedUser) => selectedUser._id === usuario._id);
    if (userIndex === -1) {
      // Se não estiver na lista, adicione-o
      newSelectedUsuarios.push(usuario);
    } else {
      // Se já estiver na lista, remova-o
      newSelectedUsuarios.splice(userIndex, 1);
    }
    setFiltro({ ...filtro, usuarios: newSelectedUsuarios });
  };

  const handleToggleProdutos = (produto) => () => {
    const newSelectedUsuarios = [...filtro.produtos];
    const userIndex = newSelectedUsuarios.findIndex((selectedUser) => selectedUser._id === produto._id);
    if (userIndex === -1) {
      newSelectedUsuarios.push(produto);
    } else {
      newSelectedUsuarios.splice(userIndex, 1);
    }
    setFiltro({ ...filtro, produtos: newSelectedUsuarios });
  };

  const handleConfirm = () => {
    props.onConfirm(filtro);
  };
  return (
    <Popover
      open={Boolean(props.open)}
      anchorEl={props.open}
      onClose={props.onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          width: 'auto+10',
          height: '100%',
          flex: 1,
          display: 'flex',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
          },
        },
      }}
    >
      <Stack flex={1} gap={1} sx={{ height: 'auto' }}>
        <Stack direction={'row'} gap={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
            <DatePicker
              open={openCalendar1}
              onOpen={handleCalendarOpen1}
              onClose={handleCalendarClose1}
              value={filtro.datainicial}
              onChange={handleDateChange1}
              renderInput={(params) => <TextField {...params} label="Data Inicial" />}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
            <DatePicker
              open={openCalendar2}
              onOpen={handleCalendarOpen2}
              onClose={handleCalendarClose2}
              value={filtro.datafinal}
              onChange={handleDateChange2}
              renderInput={(params) => <TextField {...params} label="Data Final" />}
            />
          </LocalizationProvider>
        </Stack>

        <TextField
          label="Usuários"
          disabled={!isSupervisor}
          onClick={() => isSupervisor && setOpen(!open)}
          value={filtro?.usuarios?.map((usuario) => usuario.nome).join(', ')}
        />
        {open && (
          <Paper>
            <List>
              {usuarios.map((usuario) => (
                <ListItem key={usuario._id} dense button onClick={handleToggle(usuario)}>
                  <Checkbox
                    edge="start"
                    checked={filtro.usuarios.some((selectedUser) => selectedUser._id === usuario._id)}
                    tabIndex={-1}
                    disableRipple
                  />
                  <ListItemText primary={usuario.nome} />
                </ListItem>
              ))}
            </List>
          </Paper>
        )}

        <Autocomplete
          disablePortal
          id="cliente"
          value={filtro.cliente}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, cliente: newValue });
          }}
          options={clientes}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome} - ${option.cpf}`}
          renderInput={(params) => <TextField {...params} label="Cliente" />}
        />

        <Autocomplete
          disablePortal
          id="estado"
          value={filtro.estado}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, estado: newValue });
          }}
          options={estados}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Estado" />}
        />

        <Autocomplete
          disablePortal
          id="cidade"
          value={filtro.cidade}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, cidade: newValue });
          }}
          options={cidades}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Cidade" />}
        />

        <TextField
          label="Produtos"
          onClick={() => setOpenProdutos(!openProdutos)}
          value={filtro?.produtos?.map((produto) => produto.nome).join(', ')}
        />
        {openProdutos && (
          <Paper>
            <List>
              {produtos.map((produto) => (
                <ListItem key={produto._id} dense button onClick={handleToggleProdutos(produto)}>
                  <Checkbox
                    edge="start"
                    checked={filtro.produtos?.some((selected) => selected._id === produto._id)}
                    tabIndex={-1}
                    disableRipple
                  />
                  <ListItemText primary={produto.nome} />
                </ListItem>
              ))}
            </List>
          </Paper>
        )}

        <Autocomplete
          disablePortal
          id="origem"
          value={filtro.origem || null}
          options={origem}
          isOptionEqualToValue={(option, value) => option.nome === value.nome}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Origem" />}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, origem: newValue });
          }}
        />

        <Autocomplete
          disablePortal
          id="unidade"
          disabled={!isSupervisor}
          value={filtro.unidade || null}
          options={unidades}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Unidade" />}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, unidade: newValue });
          }}
        />

        <Autocomplete
          disablePortal
          id="pagamento"
          value={filtro.pagamento}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, pagamento: newValue });
          }}
          options={pagamento}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Forma de Pagamento" />}
        />

        <Autocomplete
          disablePortal
          id="sexo"
          value={filtro.sexo}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, sexo: newValue });
          }}
          options={sexos}
          isOptionEqualToValue={(option, value) => option === value}
          getOptionLabel={(option) => `${option}`}
          renderInput={(params) => <TextField {...params} label="Gênero" />}
        />

        <Autocomplete
          disablePortal
          id="fluxos"
          value={filtro.fluxo}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, fluxo: newValue });
          }}
          options={fluxos}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Fluxo" />}
        />

        <Container sx={{ marginTop: 2 }}>
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Button variant={'outlined'} onClick={props.onLimpar}>
              Limpar
            </Button>

            <Button variant={'contained'} color={'success'} onClick={handleConfirm}>
              Filtrar
            </Button>
          </Stack>
        </Container>
      </Stack>
    </Popover>
  );
});

PopoverFiltroHome.propTypes = {
  open: PropTypes.object,
  onClose: PropTypes.func,
  onLimpar: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default PopoverFiltroHome;